import { firstValueFrom } from "rxjs";
import { IModalService } from "@zaeper/angular-dashboard-view-lib";
import { IDeveloperBillingRestClient } from "../../rest-clients/billing/i-developer-billing-rest.client";
import { BillingCountryModalComponent } from "./billing-country-modal.component";

/**
 * Makes sure the developer has a billing customer before anything is paid: asks the billing country when there is
 * none. Resolves false when the developer cancels.
 */
export async function ensureBillingCustomer( modalService: IModalService, billingRestClient: IDeveloperBillingRestClient ): Promise<boolean> {
  if ( await billingRestClient.getCustomer() ) {
    return true;
  }
  const ref = modalService.open( BillingCountryModalComponent, {
    styleClass: "bg-white rounded-lg",
    showHeader: false,
    width: "480px",
    closeOnEscape: true
  } );
  return ( await firstValueFrom( ref.onClose ) ) === true;
}
